module.exports = __webpack_public_path__ + "static/media/IMG_2989.165d9b3f.jpg";